/**
 * @generated SignedSource<<1a9387b1704142bd93709e361e7777cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteProjectDialog_project$data = {
  readonly id: string;
  readonly projectName: string;
  readonly projectNumber: string | null | undefined;
  readonly " $fragmentType": "DeleteProjectDialog_project";
};
export type DeleteProjectDialog_project$key = {
  readonly " $data"?: DeleteProjectDialog_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteProjectDialog_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteProjectDialog_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectNumber",
      "storageKey": null
    }
  ],
  "type": "Project",
  "abstractKey": null
};

(node as any).hash = "8ebc63a6156bb7749328a2c714911d37";

export default node;
